import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  biReportingToolArray,
  biFrequencyOfUpdateArray,
  biDataSourcesArray,
  biMainMetricsArray,
  biInteractiveFeaturesArray,
  biOutputArray,
  biMspPlatformArray,
  comparisonArray,
  servicesNeedArray,
  regularityArray,
  visualizationsArray,
  templateArray,
  reportingRequirementsArray,
} from './SharedConstants';

const businessIntelligencePages = [
  {
    label: 'Dashboard',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
    fields: [
      {
        fieldName: 'ReportingRequirements',
        label: 'Analysis Features',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: reportingRequirementsArray,
      },
      {
        fieldName: 'DetailedReportingRequirements',
        label: 'Analysis Features (Other)',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.ReportingRequirements || !item.ReportingRequirements.includes('Other'),
      },
      {
        fieldName: 'BitoolSelection',
        label: 'BI Tool Selection',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biReportingToolArray.map((b) => b.label)),
      },
      {
        fieldName: 'FrequencyOfUpdate',
        label: 'Frequency of update',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biFrequencyOfUpdateArray.map((f) => f.label)),
      },
      {
        fieldName: 'DataSourcesOtherThanMs',
        label: 'Data sources other than MS',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biDataSourcesArray.map((d) => d.label)),
      },
      {
        fieldName: 'BiMainMetrics',
        label: 'Main metrics',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: biMainMetricsArray,
      },
      {
        fieldName: 'Comparison',
        label: 'Comparison',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: comparisonArray,
      },
      {
        fieldName: 'ComparisonDescription',
        label: 'Please Describe',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.Comparison || !item.Comparison.includes('Other'),
      },
      {
        fieldName: 'AdditionalVisualizations',
        label: 'Additional Visualizations',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: visualizationsArray,
      },
      {
        fieldName: 'InsightHighlights',
        label: 'Insight Highlights',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'InteractiveFeatures',
        label: 'Interactive Features',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: biInteractiveFeaturesArray,
      },
      {
        fieldName: 'SubDashboards',
        label: 'Sub dashboards',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'SubDashboardsDescription',
        label: 'If yes, please describe Sub Dashboards',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'Mspplatform',
        label: 'MSP Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biMspPlatformArray.map((m) => m.label)),
      },
    ],
  },
  {
    label: 'Presentation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
    fields: [
      {
        fieldName: 'Template',
        label: 'Template',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(templateArray.map((t) => t.label)),
      },
      {
        fieldName: 'Output',
        label: 'Output',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(biOutputArray.map((o) => o.label)),
      },
      {
        fieldName: 'BiNumVisualizations',
        label: 'Number of visualizations (slides)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Kpianalysis',
        label: 'KPI analysis',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'BenchmarkingAgainstIndustry',
        label: 'Benchmarking against industry',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'SourcesTypeOfPrograms',
        label: 'Sources / type of programs',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenEndsAnalyzed',
        label: 'Number of Open Ends to Be Analyzed',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumEvalPerCycle',
        label: 'Number of Evaluations per cycle',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
    ],
  },
  {
    label: 'BI Analysis',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
    fields: [
      {
        fieldName: 'TextAnalyticsVerbatimNonEnglish',
        label: 'Will verbatims include languages other than English?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TextAnalyticsVerbatimDescription',
        label: 'If yes, please describe',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.TextAnalyticsVerbatimNonEnglish !== 'true',
      },
      {
        fieldName: 'TextAnalyticsOutputsNonEnglish',
        label: 'Will outputs be in languages other than English? If yes, please include which languages.',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'ServicesNeed',
        label: 'Services Need',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: servicesNeedArray,
      },
    ],
  },
  {
    label: 'Consultancy',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
    fields: [
      {
        fieldName: 'BiconsultancyDescription',
        label: 'Please describe what consulting is needed',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Questionnaire',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Short Answer Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'RequiredLanguageCode',
        label: 'Required Language(s) reporting',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'Regularity',
        label: 'Regularity',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(regularityArray.map((r) => r.label)),
      },
      {
        fieldName: 'SpecificRequirements',
        label: 'Please enter here specific requirements (e.g., live presentation, special score tier definition)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TopIssues',
        label:
          'Top issues that are concerning you/client at the moment and should be addressed in the report/analysis?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
];

export default businessIntelligencePages;
